import Head from './container';

export default Head;
